import { SettlementInstructionTypeSelector } from '../../../../constants';
import { isCryptoCurrencySelector } from '../CryptoDepositWithdrawal/crypto_utils';

export const computeSubTypeFilter = (isCrytoEnv: boolean) => {
  const typesToAvoid: string[] = [SettlementInstructionTypeSelector.CA_DVP, SettlementInstructionTypeSelector.CA_RVP];
  if (isCrytoEnv) {
    typesToAvoid.push(
      SettlementInstructionTypeSelector.CA_DFP,
      SettlementInstructionTypeSelector.CA_PMO,
      SettlementInstructionTypeSelector.CA_RFP,
      SettlementInstructionTypeSelector.CA_RMO,
      SettlementInstructionTypeSelector.CROSS_CSD_DFP,
      SettlementInstructionTypeSelector.CROSS_CSD_RFP,
      SettlementInstructionTypeSelector.DVP,
      SettlementInstructionTypeSelector.PMO,
      SettlementInstructionTypeSelector.RVP,
      SettlementInstructionTypeSelector.RMO,
      SettlementInstructionTypeSelector.ASSET_SUBBALANCE_TRANSFER,
    );
  }
  return (t: string): boolean => {
    return !typesToAvoid.includes(t) && !isCryptoCurrencySelector(t);
  };
};
